import { render, staticRenderFns } from "./AnnouncementBoard.vue?vue&type=template&id=5a55d25e"
import script from "./AnnouncementBoard.vue?vue&type=script&lang=js"
export * from "./AnnouncementBoard.vue?vue&type=script&lang=js"
import "./AnnouncementBoard.vue?vue&type=style&index=0&id=5a55d25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports